/* Print-artwork spec checks. Keep in sync with ezink/artwork_check.py */
(function (global) {
  var BLEED_IN = 0.125;
  var MAX_BYTES = 20 * 1024 * 1024;
  var SMALL_DPI = 300;
  var LARGE_DPI = 150;
  var LARGE_DPI_FLOOR = 100;
  var ASPECT_TOL = 0.08;
  var MIN_FILE_BYTES = 8 * 1024;
  var ALLOWED = {
    pdf: 1, ai: 1, eps: 1, psd: 1, tif: 1, tiff: 1,
    png: 1, jpg: 1, jpeg: 1, svg: 1, zip: 1, webp: 1
  };
  var RGB = { png: 1, jpg: 1, jpeg: 1, webp: 1 };
  var NO_PREVIEW = { ai: 1, eps: 1, psd: 1, zip: 1 };
  var LARGE_HINTS = ["banner", "flag", "sign", "canopy", "vinyl", "mesh", "feather", "yard sign", "event tent"];
  var SIZE_RE = /(\d+(?:\.\d+)?)\s*(?:"|in|inch|inches)?\s*[x×]\s*(\d+(?:\.\d+)?)/i;

  function issue(level, code, message) {
    return { level: level, code: code, message: message };
  }

  function parseSizeInches() {
    for (var i = 0; i < arguments.length; i++) {
      var text = arguments[i];
      if (!text) continue;
      var m = String(text).replace(/″/g, '"').match(SIZE_RE);
      if (!m) continue;
      var a = parseFloat(m[1]);
      var b = parseFloat(m[2]);
      if (a > 0 && b > 0 && a <= 240 && b <= 240) return [a, b];
    }
    return null;
  }

  function isLargeFormat(title, tags, ptype) {
    var blob = (title + " " + tags + " " + ptype).toLowerCase();
    return LARGE_HINTS.some(function (h) { return blob.indexOf(h) !== -1; });
  }

  function defaultSize(title, tags) {
    var blob = (title + " " + tags).toLowerCase();
    if (blob.indexOf("business card") !== -1 || blob.indexOf("business-cards") !== -1) return [3.5, 2];
    if (blob.indexOf("postcard") !== -1) return [4, 6];
    return null;
  }

  function sidesFor(title, tags) {
    var blob = (title + " " + tags).toLowerCase();
    if (/single[ -]?sided|4\/0/.test(blob)) return 1;
    if (/double[ -]?sided|table tent|business card|business-cards|4\/4/.test(blob)) return 2;
    if (isLargeFormat(title, tags, "")) return 1;
    return 2;
  }

  function specFromProduct(opts) {
    opts = opts || {};
    var title = opts.title || "";
    var handle = opts.handle || "";
    var tags = opts.tags || "";
    var ptype = opts.type || "";
    var templates = opts.templates || "";
    var size = parseSizeInches(title, handle.replace(/-/g, " "), templates) || defaultSize(title, tags);
    var large = isLargeFormat(title, tags, ptype);
    var spec = {
      widthIn: size ? size[0] : null,
      heightIn: size ? size[1] : null,
      dpi: large ? LARGE_DPI : SMALL_DPI,
      largeFormat: large,
      sides: sidesFor(title, tags),
      label: title || "this product"
    };
    if (size) spec.label = size[0] + " × " + size[1] + '"';
    return spec;
  }

  function specFromEl(el) {
    if (!el) return specFromProduct({});
    var spec = specFromProduct({
      title: el.getAttribute("data-ezink-title") || "",
      handle: el.getAttribute("data-ezink-handle") || "",
      tags: el.getAttribute("data-ezink-tags") || "",
      type: el.getAttribute("data-ezink-type") || "",
      templates: el.getAttribute("data-ezink-templates") || ""
    });
    var form = (el.closest && el.closest("form")) || document;
    var color = form.querySelector && form.querySelector('[data-ezink-print-opt="colorspec"]');
    if (color && color.value) {
      var raw = String(color.value).toLowerCase();
      if (raw.indexOf("back") !== -1 && raw.indexOf("4/0") === -1) spec.sides = 2;
      else if (
        raw === "front" ||
        raw.indexOf("4/0") !== -1 ||
        (raw.indexOf("front") !== -1 && raw.indexOf("back") === -1)
      ) {
        spec.sides = 1;
      } else {
        spec.sides = 2;
      }
    }
    return spec;
  }

  function specFromItem(root, item) {
    var spec = specFromEl(root);
    if (!item) return spec;
    var wEl = item.querySelector("[data-ezink-art-w]");
    var hEl = item.querySelector("[data-ezink-art-h]");
    var w = wEl ? parseFloat(wEl.value) : 0;
    var h = hEl ? parseFloat(hEl.value) : 0;
    if (w > 0 && h > 0) {
      spec.widthIn = w;
      spec.heightIn = h;
      spec.label = w + " × " + h + '"';
    }
    return spec;
  }

  function extension(filename) {
    var name = String(filename || "").split("?")[0].split("#")[0];
    name = name.split("/").pop().toLowerCase();
    var dot = name.lastIndexOf(".");
    return dot === -1 ? "" : name.slice(dot + 1);
  }

  function checkFileMeta(filename, sizeBytes) {
    var issues = [];
    var ext = extension(filename);
    if (sizeBytes > MAX_BYTES) {
      issues.push(issue("error", "too-large", "File is over 20 MB. Upload a smaller file or paste a Drive / Dropbox / WeTransfer link."));
    }
    if (sizeBytes && sizeBytes < MIN_FILE_BYTES) {
      issues.push(issue("warn", "tiny-file", "This file is very small and may be a screenshot or a compressed web image."));
    }
    if (ext && !ALLOWED[ext]) {
      issues.push(issue("error", "type", "." + ext + " is not a print file we accept. Use PDF (preferred), AI, EPS, PNG, JPG, TIFF, or ZIP."));
    }
    if (RGB[ext]) {
      issues.push(issue("warn", "rgb", "This is an RGB screen file. We print CMYK — bright neons may shift. A press-quality PDF is better."));
    }
    if (NO_PREVIEW[ext]) {
      issues.push(issue("info", "native", "Browser can’t preview this file type. We’ll open it in production software and send a proof if needed."));
    }
    if (ext === "svg") {
      issues.push(issue("info", "svg", "SVG is vector (resolution is fine). Convert fonts to outlines if the file includes type."));
    }
    return { issues: issues, ext: ext };
  }

  function orient(pxW, pxH, trimW, trimH) {
    var arFile = pxW / pxH;
    var arTrim = trimW / trimH;
    var arSwap = trimH / trimW;
    if (Math.abs(arFile - arSwap) < Math.abs(arFile - arTrim)) {
      return { pxW: pxW, pxH: pxH, trimW: trimH, trimH: trimW };
    }
    return { pxW: pxW, pxH: pxH, trimW: trimW, trimH: trimH };
  }

  function checkRaster(widthPx, heightPx, spec) {
    var issues = [];
    if (widthPx < 32 || heightPx < 32) {
      issues.push(issue("warn", "tiny-pixels", "Image is too small to print."));
      return issues;
    }
    if (!spec.widthIn || !spec.heightIn) {
      var longEdge = Math.max(widthPx, heightPx);
      var floorGuess = spec.largeFormat ? 1500 : 1000;
      if (longEdge < floorGuess) {
        issues.push(issue("warn", "low-res-guess", "Image is " + widthPx + "×" + heightPx + " px. That is usually too small for print. Aim for at least " + spec.dpi + " DPI at final size."));
      }
      return issues;
    }
    var o = orient(widthPx, heightPx, spec.widthIn, spec.heightIn);
    var dpiTrim = Math.min(o.pxW / o.trimW, o.pxH / o.trimH);
    var floor = spec.largeFormat ? LARGE_DPI_FLOOR : Math.round(SMALL_DPI * 0.85);
    var arFile = o.pxW / o.pxH;
    var arTrim = o.trimW / o.trimH;
    if (Math.abs(arFile - arTrim) / arTrim > ASPECT_TOL) {
      issues.push(issue("warn", "aspect", "File shape doesn’t match " + spec.label + ". We may have to crop or add border."));
    }
    if (dpiTrim < floor) {
      issues.push(issue("warn", "low-res", "About " + Math.round(dpiTrim) + " DPI at " + spec.label + " (" + widthPx + "×" + heightPx + " px). Need ~" + spec.dpi + " DPI" + (spec.largeFormat ? " (100–150 DPI is usually enough for banners and signs)" : " for this size") + "."));
      return issues;
    }
    var bleedPx = 2 * BLEED_IN * spec.dpi;
    if (bleedPx >= 40) {
      var bleedW = o.trimW + 2 * BLEED_IN;
      var bleedH = o.trimH + 2 * BLEED_IN;
      var hasBleed = o.pxW >= bleedW * spec.dpi * 0.97 && o.pxH >= bleedH * spec.dpi * 0.97;
      if (!hasBleed) {
        issues.push(issue("warn", "bleed", "File looks like trim size without bleed (~" + Math.round(dpiTrim) + " DPI at " + spec.label + "). Extend background 0.125\" past trim on all sides."));
      }
    }
    return issues;
  }

  function checkPdfPage(widthIn, heightIn, pages, spec) {
    var issues = [];
    if (pages < 1) return issues;
    if (spec.sides === 2 && pages === 1) {
      issues.push(issue("info", "one-page", "PDF has 1 page. This product is usually two-sided — attach a back file or a 2-page PDF."));
    }
    if (!spec.widthIn || !spec.heightIn) return issues;
    var o = orient(widthIn, heightIn, spec.widthIn, spec.heightIn);
    var bleedW = o.trimW + 2 * BLEED_IN;
    var bleedH = o.trimH + 2 * BLEED_IN;
    var errTrim = Math.max(Math.abs(o.pxW - o.trimW) / o.trimW, Math.abs(o.pxH - o.trimH) / o.trimH);
    var errBleed = Math.max(Math.abs(o.pxW - bleedW) / bleedW, Math.abs(o.pxH - bleedH) / bleedH);
    if (errBleed <= 0.04) return issues;
    if (errTrim <= 0.04) {
      issues.push(issue("warn", "bleed", "PDF page is " + o.pxW.toFixed(2) + "×" + o.pxH.toFixed(2) + "\" — that’s trim without bleed. Need " + bleedW.toFixed(2) + "×" + bleedH.toFixed(2) + "\" (0.125\" bleed on each side)."));
      return issues;
    }
    if (o.pxW + 0.05 < o.trimW || o.pxH + 0.05 < o.trimH) {
      issues.push(issue("warn", "page-small", "PDF page is " + o.pxW.toFixed(2) + "×" + o.pxH.toFixed(2) + "\", smaller than " + spec.label + ". It will be scaled up or boarded."));
    } else if (errBleed > 0.12 && errTrim > 0.12) {
      issues.push(issue("warn", "page-size", "PDF page is " + o.pxW.toFixed(2) + "×" + o.pxH.toFixed(2) + "\". Expected about " + spec.label + " plus bleed (" + bleedW.toFixed(2) + "×" + bleedH.toFixed(2) + "\")."));
    }
    return issues;
  }

  function summary(issues) {
    if (!issues || !issues.length) return "Looks in spec";
    return issues.map(function (i) { return i.message; }).join(" ");
  }

  function hasWarn(issues) {
    return (issues || []).some(function (i) { return i.level === "error" || i.level === "warn"; });
  }

  var api = {
    MAX_BYTES: MAX_BYTES,
    parseSizeInches: parseSizeInches,
    specFromProduct: specFromProduct,
    specFromEl: specFromEl,
    specFromItem: specFromItem,
    extension: extension,
    checkFileMeta: checkFileMeta,
    checkRaster: checkRaster,
    checkPdfPage: checkPdfPage,
    summary: summary,
    hasWarn: hasWarn,
    NO_PREVIEW: NO_PREVIEW,
    RGB: RGB
  };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  global.EZINKArtCheck = api;
})(typeof window !== "undefined" ? window : globalThis);
